import { BookingStateRedux } from "./states";
import { PayloadAction } from "@reduxjs/toolkit";

export default {
  // application settings
  setCurrency(state, value) {
    state.currency = value;
  },
  setIsActive(state, value) {
    state.isActive = value;
  },
  setIsEmbedded(state, { payload: value }) {
    state.isEmbedded = value;
    // console.log(value);
  },
  setIsLogged(state, value) {
    state.isLoggedIn = !!value;
  },
  setRentalTerms(state, { payload: value }) {
    state.rentalTerms = value;
  },

  // APIs
  setBookingInformation(
    state,
    { payload: value }: PayloadAction<BookingStateRedux["bookingInformation"]>
  ) {
    state.bookingInformation = {
      ...value,
      dropOffDateAndTime: new Date(
        value.dropOffDateAndTime || Date.now()
      ).getTime(),
      pickUpDateAndTime: new Date(
        value.pickUpDateAndTime || Date.now()
      ).getTime(),
    } as BookingStateRedux["bookingInformation"];
  },
  resetBookingInformation(state) {
    state.bookingInformation = {
      pickUpDateAndTime: new Date().getTime(),
      dropOffDateAndTime: new Date().getTime(),
      dropOffLocationDetails: {
        code: "",
        dealerId: "",
        dealerName: "",
        locationDescription: "",
        email: "",
        latitude: "",
        longitude: "",
        locationWithDealerName: "",
        name: "",
      },
      pickUpLocationDetails: {
        code: "",
        dealerId: "",
        dealerName: "",
        locationDescription: "",
        email: "",
        latitude: "",
        longitude: "",
        locationWithDealerName: "",
        name: "",
      },
      reservationSource: "",
      showPics: false,
      showOptionalImage: false,
      showVehicleParameter: false,
      showVehicleExtraImage: false,
      showBookingDiscount: false,
      agreementCoupon: "",
      macroGroupName: "",
      isPayLaterFee: false,
      payLaterFeeAmt: "",
      pickUpLocationName: "",
      dropOffLocationName: "",
    };
  },

  setSessionExpiryTime(
    state: BookingStateRedux,
    { payload: value }: PayloadAction<BookingStateRedux["sessionExpiryTime"]>
  ) {
    state.sessionExpiryTime = value;
  },
  setSelectedVehicleDetails(
    state: BookingStateRedux,
    {
      payload: value,
    }: PayloadAction<BookingStateRedux["selectedVehicleDetails"]>
  ) {
    state.selectedVehicleDetails = {
      vehicleDetails: {
        optionals: [],
        Status: "Unavailable",
        TotalCharge: null,
        Vehicle: undefined,
      },

      paymentDetails: {
        // ...value.paymentDetails,
        selectedInsurance: value.paymentDetails?.selectedInsurance || {
          price: 0,
          details: "",
          name: "insurance",
        },
        addedExtraOptions: value.paymentDetails?.addedExtraOptions || {},
        type: value.paymentDetails?.type || "PAYNOW",
        price: ((value.paymentDetails?.price || 0) * 100) / 100,
      },
      ...value,
    };
  },
  setUserDetails(
    state: BookingStateRedux,
    { payload: value }: PayloadAction<BookingStateRedux["userDetails"]>
  ) {
    state.userDetails = value;
  },
  setSelectedFields(
    state: BookingStateRedux,
    { payload: value }: PayloadAction<BookingStateRedux["selectedFields"]>
  ) {
    state.selectedFields = value;
  },
  setPrices(
    state: BookingStateRedux,
    { payload: value }: PayloadAction<BookingStateRedux["priceDetailsRedux"]>
  ) {
    state.priceDetailsRedux = value;
  },
  setAppSetting(
    state: BookingStateRedux,
    { payload: value }: PayloadAction<BookingStateRedux["appSetting"]>
  ) {
    state.appSetting = value;
  },

  setTextResource(
    state: BookingStateRedux,
    { payload: value }: PayloadAction<BookingStateRedux["textresource"]>
  ) {
    state.textresource = value;
  },

  setPaymentMethods(
    state: BookingStateRedux,
    { payload: value }: PayloadAction<BookingStateRedux["paymentInfo"]>
  ) {
    state.paymentInfo = value;
  },
};
